import Vue from 'vue';
import storage from '@/helpers/storage'
export const locale = new Vue({
// Language object containing labels for different languages
  data: {
    lang: storage.get('user-lang') || 'en_US', // set default
    lang_obj: {
      en_US: require('./en.json'),
      es_ES: require('./es.json'),
      pt_BR: require('./pt.json'),
      pl_PL: require('./pl.json'),
      hu_HU: require('./hu.json'),
      zh_CN: require('./cn.json'),
      zh_TW: require('./bg.json'), // traditional chinese (zh, zh_TW) is used for bulgarian instead (bg, bg_BG) since okta doesnt support BG natively
      it_IT: require('./it.json'),
      ro_RO: require('./ro.json'),
      de_DE: require('./de.json'),
      nl_NL: require('./nl.json'),
      fr_FR: require('./fr.json'),
      ru_RU: require('./ru.json'),
      uk_UK: require('./uk.json'),
      es_AR: require('./es.json'),
      tr_TR: require('./tr.json'),
      ko_KR: require('./ko.json')
    },
    lang_def: [{'langCode': 'en_US', 'langName': 'English'},
      {'langCode': 'pt_BR', 'langName': 'Portuguese'},
      {'langCode': 'es_ES', 'langName': 'Spanish'},
      {'langCode': 'pl_PL', 'langName': 'Polish'},
      {'langCode': 'hu_HU', 'langName': 'Hungarian'},
      {'langCode': 'zh_TW', 'langName': 'Bulgarian'},
      {'langCode': 'zh_CN', 'langName': 'Chinese'},
      {'langCode': 'it_IT', 'langName': 'Italian'},
      {'langCode': 'ro_RO', 'langName': 'Romanian'},
      {'langCode': 'de_DE', 'langName': 'Deutsch'},
      {'langCode': 'nl_NL', 'langName': 'Dutch'},
      {'langCode': 'fr_FR', 'langName': 'French'},
      {'langCode': 'ru_RU', 'langName': 'Russian'},
      {'langCode': 'uk_UK', 'langName': 'Ukrainian'},
      {'langCode': 'tr_TR', 'langName': 'Turkish'},
      {'langCode': 'ko_KR', 'langName': 'Korean'}]
  }
})



// WEBPACK FOOTER //
// ./src/i18n/locale.js